import React, { useState } from "react";
import { C } from "../../../components/cameras/CamerasStyles";
import { OUTCOME_CHIP } from "../../../components/cameras/AlertsView";
import { DoorBadge } from "../../../components/cameras/DoorAlarm";
import { alertKey, alertTitle, clipTarget, outcomeLabel, shopClock } from "../../../features/security/nightWatch";
import { isDoorAlert } from "../../../features/security/doors";

// The phone Cameras screen's "Recent alerts" (2026-10-25): the last 24 h of camera AND door alerts, newest
// first, the desktop list's words (features/security nightWatch alertTitle / outcomeLabel, doors.js for a
// door row). The newest 5, then "Show all". Watch clip opens the camera's clip in the phone's own Playback
// (CamerasScreen `onWatchClip`). Layout only: the read is useNightWatchAlerts.

const SHOWN = 5;

function Row({ a, cameras, onWatchClip }) {
  const door = isDoorAlert(a);
  const chip = OUTCOME_CHIP[a.outcome] || OUTCOME_CHIP.held;
  const camera = (cameras || []).find((c) => c.key === a.camera_key);
  const clip = clipTarget(a);
  return (
    <div data-testid="phone-alert-row" data-source={door ? "door" : "camera"}
         style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "8px 0", borderTop: `1px solid ${C.border}` }}>
      <span style={{ width: 72, height: 54, flex: "0 0 auto", borderRadius: 5, overflow: "hidden", background: "#0b0d0f",
                     display: "flex", alignItems: "center", justifyContent: "center" }}>
        {a.photo_url ? (
          <a href={a.photo_url} target="_blank" rel="noreferrer" title="Open the photo full size" style={{ display: "block", width: "100%", height: "100%" }}>
            <img src={a.photo_url} alt={alertTitle(a)} style={{ width: "100%", height: "100%", objectFit: door ? "contain" : "cover", display: "block" }} />
          </a>
        ) : <span style={{ fontSize: 10, color: C.faint }}>no photo</span>}
      </span>
      <span style={{ display: "grid", gap: 4, minWidth: 0, flex: 1 }}>
        <span style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, minWidth: 0 }}>
          {door && <DoorBadge />}
          <span className="jqc-ell">{alertTitle(a)}</span>
        </span>
        <span style={{ width: "fit-content", maxWidth: "100%", fontSize: 11.5, fontWeight: 600, padding: "1px 8px", borderRadius: 999,
                       background: chip.bg, color: chip.fg, overflowWrap: "anywhere" }}>
          {outcomeLabel(a)}
        </span>
        {a.photo_note && <span style={{ fontSize: 11, color: C.faint }}>{a.photo_note}</span>}
        {camera && (
          <button type="button" className="jqc-btn" style={{ width: "fit-content", minHeight: 30, fontSize: 12 }}
                  onClick={() => onWatchClip(camera, clip.day, clip.minute)}>
            ▶ Watch {shopClock(new Date(new Date(a.seen_at).getTime() - 30000))}
          </button>
        )}
      </span>
    </div>
  );
}

export default function RecentAlerts({ alerts, error, cameras, onWatchClip }) {
  const [all, setAll] = useState(false);
  const list = alerts || [];
  const shown = all ? list : list.slice(0, SHOWN);
  return (
    <section aria-label="Recent alerts" data-testid="phone-recent-alerts" style={{ padding: "8px 12px", borderBottom: "1px solid #22272d" }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
        <b style={{ fontSize: 14 }}>Recent alerts</b>
        <span style={{ fontSize: 12, color: C.muted }}>last 24 h</span>
        <span style={{ flex: 1 }} />
        {list.length > SHOWN && (
          <button type="button" className="jqc-btn" style={{ minHeight: 30, fontSize: 12 }} aria-expanded={all} onClick={() => setAll((x) => !x)}>
            {all ? "Show fewer" : `Show all (${list.length})`}
          </button>
        )}
      </div>
      {error && <div style={{ fontSize: 12, color: C.bad, paddingTop: 4 }}>{error}</div>}
      {alerts === null && !error && <div style={{ fontSize: 12, color: C.muted, paddingTop: 4 }}>Loading alerts…</div>}
      {alerts && !list.length && <div style={{ fontSize: 12, color: C.faint, paddingTop: 4 }}>No alerts in the last 24 h.</div>}
      {shown.map((a) => <Row key={alertKey(a)} a={a} cameras={cameras} onWatchClip={onWatchClip} />)}
    </section>
  );
}
